import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.8942 4.69995L9.48116 9.62532L4 10.4201L7.97062 14.302L7.02147 19.7L11.8942 17.1023L16.7679 19.7L15.8258 14.302L19.7895 10.4201L14.3387 9.62532L11.8942 4.69995Z",
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }